<template>
  <div class="-cut -action" @click="$emit('cut')">
    <span class="wticon wticon-scissors_V8"></span>
  </div>
</template>

<script>
export default {
  name: 'AssetCut',
};
</script>
